"use client";

import { HeroSection } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import threeSixtyRoomTab from "../../../../public/images/three-sixty/360-tour-room-tab.png";

const Hero = () => {
  const t = useTranslations("threeSixtyTour.hero");

  return (
    <HeroSection
      image={threeSixtyRoomTab}
      alt={"360-Grad-Rundgang Kleidungsgeschäft"}
      tab={t("tab")}
      title={t("title")}
      text={t("text")}
      linkTitle={t("linkTitle")}
      href={"/preise"}
    />
  );
};

export default Hero;
